/* eslint-disable @typescript-eslint/no-use-before-define */
import { CounterLabel } from '@euler/app/flows/settings/components/CounterLabel';
import { useObdDeviceCount } from '@euler/app/flows/settings/functions';
import { memo } from 'react';

export const ObdDeviceCountNote = memo(() => {
  const count = useObdDeviceCount();
  return <CounterLabel value={count} />;
});
